import e from "../../hooks/useKey.js";
import "../../useKey.js";
import t from "../../utils/classNames.js";
import { usePopover as n } from "../../hooks/useAnchoredPopover.js";
import r from "./DropdownHeader.js";
import { DOWN as i, scrollItemIntoView as a } from "../../utils/scrollItemIntoView.js";
import o from "./NoItemMessage.js";
import s from "../spinner/Spinner.js";
import { useEffect as c, useRef as l, useState as u } from "react";
import { noop as d } from "es-toolkit/function";
import { isEmpty as f } from "es-toolkit/compat";
import { Fragment as p, jsx as m, jsxs as h } from "react/jsx-runtime";
//#region src/components/selects/BaseSelectDropdown.tsx
var g = "data-item-id", ee = 0, _ = "focus", v = i, y = (y) => {
	let { isOpen: b = !1, isLoading: x = !1, updateDOMValues: S = d, onOpen: C = d, onSelect: w = d, onClose: T = d, options: E = [], dropup: D = !1, pullRight: O = !1, useActiveClass: k = !1, focusedItemIndex: A, keyboardUsed: j, noItemMessage: M, dropdownClassName: N, anchorName: P } = y, [F, I] = u(A || ee), [L, R] = u(j), z = l(v), B = l(null), V = f(E), H = P ? { positionAnchor: P } : void 0;
	n(B, b, [V, !!M]), c(() => {
		b && B.current && (B.current.scrollTop = 0);
	}, [b]), c(() => {
		typeof A == "number" && I(A), typeof j == "boolean" && R(j), b || (z.current = v);
	}, [
		A,
		j,
		b
	]), c(() => {
		S(q());
	}, [E]), c(() => {
		b && a(z.current || v, B.current, J());
	}, [F, b]);
	let [U, W] = u(b);
	b && !U ? (C(D), W(b)) : !b && U && (T(), W(b)), e((e) => {
		if (b) switch (e.key) {
			case "Escape":
				T();
				break;
			case "Tab":
				T();
				break;
			case "Enter":
				Y(e);
				break;
			case "ArrowUp":
				e.preventDefault(), G("up"), a("up", B.current, J());
				break;
			case "ArrowDown": e.preventDefault(), G(i), a(i, B.current, J());
		}
	});
	let G = (e) => {
		let t = 0;
		switch (e) {
			case "up":
				t = F <= 0 ? F : F - 1;
				break;
			case i: t = F === E.length - 1 ? F : F + 1;
		}
		z.current = e;
		let n = e === "up" ? E.length - 1 : 0;
		I(t < 0 ? n : t), R(!0);
	}, K = () => B.current?.getElementsByTagName("a") || [], q = () => {
		if (B.current) return [...K()].map((e) => ({
			id: e.getAttribute(g),
			text: e.textContent
		}));
	}, J = () => [...K()].find((e) => e.className.includes(_)), Y = (e) => {
		if (e.preventDefault(), f(E)) return;
		let t = J();
		if (t) {
			let e = E.find((e) => e.id === t.getAttribute(g));
			w(e);
		}
	}, X = (e) => {
		e.preventDefault();
		let t = e.currentTarget.getElementsByTagName("input")[0].value, n = E.find((e) => e.id === t);
		w(n);
	}, Z = N?.split(/\s+/).some((e) => e.startsWith("width-") || e.startsWith("max-width-")), Q = t("dropdown-menu", !Z && "dropdown-menu-anchor-width", N, O && "pull-right"), $ = { popover: "manual" };
	return V ? /* @__PURE__ */ m(o, {
		...$,
		noItemMessage: M,
		className: Q,
		ref: B,
		style: H
	}) : /* @__PURE__ */ h("ul", {
		...$,
		className: Q,
		ref: B,
		role: "menu",
		style: H,
		children: [x && /* @__PURE__ */ m("div", {
			className: "display-flex justify-content-center padding-10",
			children: /* @__PURE__ */ m(s, {})
		}), !x && E.map((e, n) => {
			if (e.header) return /* @__PURE__ */ m(r, {
				icon: e.icon,
				label: e.label
			}, e.id);
			let i = t(L && F === n ? _ : "", e.disabled && "pointer-events-none", "display-flex align-items-center gap-3", e.dropdownItemClassName), a = t(e.disabled && "disabled", k && e.selected && "active");
			return /* @__PURE__ */ m("li", {
				className: a,
				role: "listitem",
				children: /* @__PURE__ */ h("a", {
					role: "menuitem",
					className: i,
					"data-item-id": e.id,
					"data-item-index": n,
					onClick: e.disabled ? void 0 : X,
					children: [/* @__PURE__ */ h("span", {
						className: t("selected-option-dropdown-item", !!e.description && "selected-option-dropdown-item-with-description"),
						children: [e.icon && /* @__PURE__ */ m(p, { children: e.icon }), e.description ? /* @__PURE__ */ h("span", {
							className: "selected-option-dropdown-text",
							children: [/* @__PURE__ */ m("span", {
								className: "selected-option-dropdown-label",
								children: e.label
							}), /* @__PURE__ */ h("span", {
								className: "selected-option-dropdown-description",
								children: [" ", e.description]
							})]
						}) : e.label]
					}), /* @__PURE__ */ m("input", {
						type: "hidden",
						value: e.id
					})]
				})
			}, e.id);
		})]
	});
}, b = (e, t, n) => {
	let r = e.filter((e) => e.text.toLowerCase().includes(t.toLowerCase()));
	return n.filter((e) => r.find((t) => t.id === e.id));
};
//#endregion
export { y as default, b as filterOptions };

//# sourceMappingURL=BaseSelectDropdown.js.map